export type Duration = {
  days: number;
  hours: number;
  minutes: number;
  seconds: number;
};

export type IntervalInput = {
  start: Date | string | number;
  end: Date | string | number;
};

// This function must be fully self-contained and not rely on any external dependencies so it can be inlined into html
export function intervalToDuration(interval: IntervalInput): Duration {
  const startMs = new Date(interval.start).getTime();
  const endMs = new Date(interval.end).getTime();
  const totalSeconds = Math.max(0, Math.floor((endMs - startMs) / 1000));

  return {
    days: Math.floor(totalSeconds / 86_400),
    hours: Math.floor((totalSeconds % 86_400) / 3_600),
    minutes: Math.floor((totalSeconds % 3_600) / 60),
    seconds: totalSeconds % 60,
  };
}
